import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-add-mentor-to-member',
  templateUrl: './add-mentor-to-member.component.html',
  styleUrls: ['./add-mentor-to-member.component.scss']
})
export class AddMentorToMemberComponent implements OnInit {
  public mentorId:number=0;

  constructor(
    public dialogRef: MatDialogRef<AddMentorToMemberComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { }

  ngOnInit() {
  }

  cancel(){
    this.dialogRef.close(false);
  }

  submit(){
    this.dialogRef.close(this.mentorId);
  }
}
